// Formatadores/masks para campos brasileiros (CPF, CNPJ, telefone).
// Cada função aceita qualquer entrada (com ou sem máscara),
// retira caracteres não-numéricos e aplica a máscara adequada.

const onlyDigits = (v) => String(v ?? "").replace(/\D+/g, "");

export const formatCpf = (v) => {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9)
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
};

export const formatCnpj = (v) => {
  const d = onlyDigits(v).slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8)
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12)
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
};

/**
 * Formata CPF ou CNPJ automaticamente.
 * Se personType === "PJ" força CNPJ; se "PF" força CPF; caso contrário decide pela contagem de dígitos.
 */
export const formatCpfCnpj = (v, personType) => {
  if (personType === "PJ") return formatCnpj(v);
  if (personType === "PF") return formatCpf(v);
  const d = onlyDigits(v);
  return d.length > 11 ? formatCnpj(d) : formatCpf(d);
};

/**
 * Formata telefone BR:
 *  - 10 dígitos → (XX) XXXX-XXXX (fixo)
 *  - 11 dígitos → (XX) XXXXX-XXXX (celular)
 *  - Menos que isso: aplica parcialmente conforme digita.
 */
export const formatPhone = (v) => {
  const d = onlyDigits(v).slice(0, 11);
  if (d.length === 0) return "";
  if (d.length < 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10)
    return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};
